import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { unitStats } from '../../../stats';

export const nexusReducer = (scratch: StatsSnapshot) => {
  const stats = unitStats.nexus;
  const generated = stats.buildingsGeneration ?? 0;

  scratch.generators.academy.owned += generated;

  return;
};
